export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-drag/src/constant.js
// module id = 247
// module chunks = 0 1 2 3 4